import { filterParams } from "../assets/helpers/funciones";
import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const fleetService = {
  getFleetMaintenances: async (params) => {
    const response = await authInstance
      .get(
        `${url}/fleetMaintenance/?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getFleetIncidences: async (params) => {
    const response = await authInstance
      .get(
        `${url}/fleetIncidence/?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getSystems: async (params) => {
    const response = await authInstance
      .get(
        `${url}/fleetMaintenance/getSystemCatalog/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getMaintenanceProviders: async (params) => {
    const response = await authInstance
      .get(
        `${url}/maintenanceProvider/list?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getComponents: async (params) => {
    const response = await authInstance
      .get(
        `${url}/fleetMaintenance/getComponentsCatalog/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  createMaintenance: async (data) => {
    const response = await authInstance
      .post(`${url}/fleetMaintenance/`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  createIncidence: async (data) => {
    const response = await authInstance
      .post(`${url}/fleetIncidence/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  EditMaintenance: async (id, data) => {
    const response = await authInstance
      .put(`${url}/fleetMaintenance/${id}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  EditIncidence: async (id, data) => {
    const response = await authInstance
      .put(`${url}/fleetIncidence/${id}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
